//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UsesAuthenticatedUser, UsesCurrency, UsesKintellGroupPermission } from '@/mixins'
import { take } from 'lodash-es'
import { KintellCard, User } from '@/models'
import { call, sync } from 'vuex-pathify'

export default {
  mixins: [
    UsesAuthenticatedUser,
    UsesCurrency,
    UsesKintellGroupPermission
  ],
  props: {
    /**
     * The card data. This should be coming directly from the API via the KintellCard model
     */
    card: {
      required: true,
      type: KintellCard,
    },
    /**
     * The user who created the kintell card. This should be on the KintellCard model, but for performance reasons we
     * request it manually
     */
    advisor: {
      type: User,
      required: true
    },
    /**
     * Whether to display the edit button at the bottom of the widget
     * Also shows chip details
     */
    editDetails: {
      type: Boolean,
      default: false
    },
    /**
     * Whether to display the share button at the bottom of the widget
     */
    shareButton: {
      type: Boolean,
      default: false
    },
    /**
     * Whether to display the remove favourite button at the bottom of the widget
     */
    removeButton: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    hideReviews: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false
    },
    /** Hides the skills and centers the rate */
    minimal: Boolean,
    hideFavourite: {
      type: Boolean,
      default: false
    },
    // disable card click
    disableClick: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      userIcon: require('~images/user-grey.svg'),
      showShareModal: false,
      loadingShortLink: false,
      // set group to dupicate a card
      selectedKintellGroup: '',
    }
  },
  computed: {
    ...sync({
      activeKintellCard: 'kintellCards/activeKintellCard',
    }),
    classes () {
      return {
        'k-kintell-card-widget--small': this.small,
        'k-kintell-card-widget--minimal': this.minimal
      }
    },
    /**
     * For small cards we only show the first 3 skills, otherwise we show all of them
     */
    skills () {
      return take(this.card.skills, 3)
    },
    shouldSeeCardStatus () {
      return this.card.friendlyStatus !== 'Published' && this.card.status
    },
    hasFooterButtons () {
      return this.editDetails || this.shareButton || this.removeButton
    },
    isGroupCard () {
      return this.card.kintellGroup && this.card.kintellGroup.id
    },
    workHistories () {
      return this.card.workHistories
    },
    showPrice () {
      if (!this.card.kintellGroup) {
        return true
      }
      return this.card.kintellGroup.pricingEnabled
    },
    canReviewCard () {
      return this.card.kintellGroupId ? this.card.kintellGroup?.canReview : true
    }
  },
  watch: {
    async showShareModal (value) {
      if (value === true && !this.card.shortLink && (this.authenticatedUser.id === this.card.createdBy)) {
        this.loadingShortLink = true
        await this.card.fetchShortLink()
        this.loadingShortLink = false
      }
    }
  },
  methods: {
    ...call({
      deleteKintellCard: 'myKintell/deleteKintellCard',
      createKintellCard: 'myKintell/createKintellCard',
      reloadKintellCards: 'myKintell/reloadKintellCards',
      reloadGroupKintellCards: 'myKintell/loadGroupKintellCards',
    }),
    removeButtonClicked () {
      this.$emit('removed')
    },

    async duplicateCard () {
      const selectedGroup = this.authenticatedUser.kintellGroups.find(group => group.id === this.selectedKintellGroup)
      if (selectedGroup && !this.hasGroupRole(this.groupRolesCollections.IS_VERIFIED_MEMBER, [ selectedGroup.role ])) {
        return this.$router.push(`${selectedGroup.link}/welcome?page=awaiting-response`)
      }
      const kintellCard = await KintellCard.include('categories', 'relevantQualifications', 'supportingLinks').find(this.card.id)
      const categories = kintellCard.categories.map(category => category.id)
      // Do not want to copy the previous card approved or rejected admin info while duplicatiing a card
      const cardApprovedRejectInfo = {
        approvedAt: null,
        approvedBy: null,
        rejectedAt: null,
        rejectedBy: null,
      }
      const model = new KintellCard({
        ...this.card,
        kintellGroupId: this.selectedKintellGroup === 'null' ? null : this.selectedKintellGroup,
        categories,
        id: null,
        ...cardApprovedRejectInfo
      })
      if (this.card.isPrivate) {
        model._from('kintell-cards/private')
        const card = await this.createKintellCard(model)
        await this.reloadKintellCards()
        this.activeKintellCard = card
        this.$router.push(card.editLink)
      } else {
        model._from('kintell-cards/listed')
        const card = await this.createKintellCard(model)
        const workHistories = kintellCard.workHistories.map(({ id, ...workHistory }) => workHistory)
        const relevantQualifications = kintellCard.relevantQualifications.map(({ id, ...relevantQualification }) => relevantQualification)
        const supportingLinks = kintellCard.supportingLinks.map(({ id, ...supportingLink }) => supportingLink)
        const duplicatedCard = await new KintellCard({
          ...card,
          // Card price rate is not carry over to cards duplicated in groups.
          rate: this.selectedKintellGroup === 'null' ? kintellCard.rate : 0,
          categories,
          workHistories,
          relevantQualifications,
          supportingLinks,
          ...cardApprovedRejectInfo
        }).save()
        await this.reloadKintellCards()
        this.activeKintellCard = duplicatedCard
        this.$router.push(duplicatedCard.editLink)
      }
    },

    async deleteCard (card) {
      await this.$refs.confirmDelete.confirm(async () => {
        await this.deleteKintellCard(card)
        // show alert
        this.$toast.success('Your Kintell Card has been deleted')
        if (card.kintellGroupId) {
          this.reloadGroupKintellCards(this.$route.params)
        } else {
          this.reloadKintellCards()
        }
      })
    },
    handleShareModal () {
      if (this.card.isAwaitingReview || this.card.isDraft) {
        return false
      }
      this.showShareModal = true
    }
  },
}
